import React from "react";
import LoginTooltip from "../LoginTooltip";

const buildStarRating = (rating, reviewCount) => {
  const stars = [];
  const numericRating = Number(rating);

  if (!reviewCount || !Number.isFinite(numericRating)) {
    for (let i = 0; i < 5; i += 1) {
      stars.push(
        <span key={i} className="text-gray-300">
          {"\u2605"}
        </span>
      );
    }
    return stars;
  }

  const fullStars = Math.floor(numericRating);
  const hasHalfStar = numericRating % 1 >= 0.5;

  for (let i = 0; i < fullStars; i += 1) {
    stars.push(
      <span key={i} className="text-yellow-400">
        {"\u2605"}
      </span>
    );
  }

  if (hasHalfStar) {
    stars.push(
      <span key="half" className="text-yellow-400">
        {"\u2606"}
      </span>
    );
  }

  const emptyStars = 5 - Math.ceil(numericRating);
  for (let i = 0; i < emptyStars; i += 1) {
    stars.push(
      <span key={`empty-${i}`} className="text-gray-300">
        {"\u2606"}
      </span>
    );
  }

  return stars;
};

const ListingHeaderActions = ({
  averageRating,
  reviewCount = 0,
  isReviewLoading = false,
  onReviewClick,
  reviewTitle = "Click to view reviews",
  favoriteActive = false,
  onFavoriteClick,
  favoriteTitle,
  favoriteAlt = "Favorite",
  loginTooltipOpen = false,
  onLoginTooltipClose,
  loginTooltipMessage,
}) => {
  const numericReviewCount = Number(reviewCount) || 0;
  const numericRating = Number(averageRating);
  const ratingLabel =
    numericReviewCount > 0 && Number.isFinite(numericRating)
      ? numericRating.toFixed(1)
      : "?";
  const reviewCountText = `${numericReviewCount} review${
    numericReviewCount === 1 ? "" : "s"
  }`;

  return (
    <div className="listing-header-actions flex flex-row gap-1 items-center flex-shrink-0">
      {!isReviewLoading && (
        <button
          type="button"
          className="listing-header-review-action flex flex-wrap justify-center items-center cursor-pointer hover:bg-blue-100 gap-1 p-1.5 rounded"
          onClick={onReviewClick}
          title={reviewTitle}
          aria-label={`${ratingLabel} stars, ${reviewCountText}. ${reviewTitle}`}
        >
          <span className="listing-header-stars flex items-center" aria-hidden="true">
            {buildStarRating(averageRating, numericReviewCount)}
          </span>
          <span className="listing-header-rating-summary flex flex-col items-center text-nowrap">
            <span className="listing-header-rating-value text-sm font-medium text-gray-700">
              {ratingLabel}
            </span>
            <span className="listing-header-review-count text-xs text-gray-500">
              <span className="listing-header-review-count-full">
                ({reviewCountText})
              </span>
              <span className="listing-header-review-count-compact hidden">
                ({numericReviewCount})
              </span>
            </span>
          </span>
        </button>
      )}

      <div className="listing-header-favorite-wrapper relative">
        <button
          type="button"
          className="listing-header-favorite-action cursor-pointer hover:bg-blue-100 p-1.5 rounded transition-colors"
          onClick={onFavoriteClick}
          title={favoriteTitle}
          aria-label={favoriteTitle}
        >
          <span className="relative">
            <img
              src="/clownfishheart-optimized.webp"
              alt={favoriteAlt}
              className="listing-header-favorite-icon w-5"
              style={{ filter: favoriteActive ? "none" : "grayscale(100%)" }}
            />
          </span>
        </button>
        <LoginTooltip
          isOpen={loginTooltipOpen}
          onClose={onLoginTooltipClose}
          message={loginTooltipMessage}
          position="bottom-right"
        />
      </div>
    </div>
  );
};

export default ListingHeaderActions;
